export default "__VITE_ASSET__64ca047c__"